<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError == '409') {
		<mat-error class="top-right-absolute-error-message">
			{{ 'mes.administration.calendar.dialog.alias.errors.duplicate' | translate }}
		</mat-error>
	}

	<h1 mat-dialog-title class="notification-title no-select">
		{{ 'mes.administration.calendar.dialog.create-calendar' | translate }}
	</h1>
	<mat-dialog-content style="padding-top: 20px">
		<div class="optional-form-fields">
			@if (controls['alias'].invalid && controls['alias'].touched) {
				<mat-error>
					{{ 'mes.administration.calendar.dialog.alias.errors.' + getFirstValidationErrorName('alias') | translate }}
				</mat-error>
			}
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'mes.administration.calendar.dialog.alias.label' | translate }}
				</mat-label>
				<input maxlength="255" matInput formControlName="alias" />
			</mat-form-field>
		</div>
	</mat-dialog-content>
	<div>
		<div mat-dialog-actions align="end">
			<button mat-flat-button color="primary" type="submit" [disabled]="loading || form.invalid">
				{{ 'mes.administration.calendar.dialog.okbtn' | translate }}
			</button>
			<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">
				{{ 'mes.administration.calendar.dialog.cancelbtn' | translate }}
			</button>
		</div>
	</div>
</form>
